// SettingsDisplayPane.jsx

import React from 'react';

// Components
import SettingsModalPaneHeader from './SettingsModalPaneHeader';
import SettingsModalPaneContents from './SettingsModalPaneContents';
import Switch from 'components/switch/Switch';

/**
 * SettingsDisplayPane
 *
 * Renders display preferences for the current base.
 *
 * @param {object} theme - Active theme tokens for dynamic styling.
 * @param {boolean} isDarkMode - Whether dark mode is enabled.
 * @param {function} onThemeModeChange - Callback invoked when the theme mode toggle changes.
 * @returns {ReactNode} The rendered display settings pane.
 */
const SettingsDisplayPane = React.memo(({
    theme,
    isDarkMode,
    onThemeModeChange,
    title = 'Display',
    subtitle = 'Space default appearance',
    settingLabel = 'Dark Mode',
    settingDescription = 'Applied as this base\'s default setting.',
    disabled = false,
}) => {

  // ----- RENDER ----- //

  return (
        <>
            <SettingsModalPaneHeader
              title={title}
              subtitle={subtitle}
            />

            <SettingsModalPaneContents>
                <div className="settings-modal-theme-card">
                    <div className="settings-modal-theme-meta">
                        <div
                          className="settings-modal-setting-label"
                          style={{
                            color: theme.foreground,
                          }}
                        >
                            {settingLabel}
                        </div>
                        <div
                          className="settings-modal-setting-description"
                          style={{
                            color: theme.foregroundMuted,
                          }}
                        >
                            {settingDescription}
                        </div>
                    </div>

                    <Switch
                      checked={isDarkMode}
                      disabled={disabled}
                      onChange={onThemeModeChange}
                    />
                </div>
            </SettingsModalPaneContents>
        </>
    );
});

// Dev Tools
SettingsDisplayPane.displayName = 'SettingsDisplayPane';

export default SettingsDisplayPane;
